export default "__VITE_ASSET__BkEhDuo6__"